import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

const NotFound = () => {
  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
      data-testid="not-found"
    >
      <Navigation />
      <section className="min-h-[90vh] flex items-center">
        <div className="mx-auto max-w-[1600px] px-5 md:px-10 w-full">
          <div className="section-label mb-6">Error 404</div>
          <h1 className="h-kinetic text-[22vw] md:text-[16vw] leading-[0.85] mb-10">
            Page not <span className="italic font-serif">found.</span>
          </h1>
          <Link
            to="/"
            data-cursor="hover"
            data-testid="back-home-404"
            className="inline-flex items-center gap-2 px-6 py-4 rounded-full border border-[color:var(--nn-border)] hover:border-[color:var(--nn-accent)] transition-colors"
          >
            <ArrowLeft size={16} /> Take me home
          </Link>
        </div>
      </section>
      <Footer />
    </motion.main>
  );
};

export default NotFound;
